<div class="logout-page-container">
  <div class="spinner-container">
    <i class="fa fa-spinner fa-pulse fa-fw" (dblclick)="toggleBlockRedirect()"></i>
    <p class="redirect-text">Redirecting you to the launchpad...</p>
  </div>
</div>
